module.exports = "/lucky-balls/img/bonus_yellow/check_infoBar/check_005.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/bonus_yellow/check_infoBar/check_005.png
// module id = 950
// module chunks = 0